import { createContext } from "react";
import { StateProps } from "../../types/props";

export const appContext = createContext<StateProps>({
  loginStatus: false,
  setLoginStatus: null,
  userSettings: null,
  setUserSettings: null,
});
